<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>{{$route.meta.title}}</h3>

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="true">
      <span slot="header">搜索</span>

      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="110px"
               label-position="right"
               size="medium"
               class="layout-search-form medium"
               @submit.native.prevent="onSearch()">
        <el-row :gutter="20">
          <el-col>
            <el-form-item label="门店："
                          prop="market">
              <el-input v-model="search.market"
                        placeholder="请输入门店名称或ID"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item label="反馈用户："
                          prop="user">
              <el-input v-model="search.user"
                        placeholder="请输入用户手机号或ID"
                        clearable></el-input>
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item label="评分："
                          prop="score">
              <el-checkbox-group v-model="search.score">
                <el-checkbox v-for="item in options.score"
                             :label="item"
                             :key="item">{{item}}星
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item prop="start_time"
                          label="反馈开始时间:">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="search.start_time"
                type="datetime"
                align="center">
              </el-date-picker>
            </el-form-item>
          </el-col>

          <el-col>
            <el-form-item prop="end_time"
                          label="反馈结束时间:">
              <el-date-picker
                value-format="yyyy-MM-dd HH:mm:ss"
                v-model="search.end_time"
                type="datetime"
                align="center">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button type="primary"
                     @click="onExportSearch()">导出
          </el-button>
          <el-button @click="resetSearch()">重置</el-button>
        </el-form-item>
      </el-form>
    </layout-panel>

    <layout-panel :show-header="false">
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row>
        <el-table-column prop="userid"
                         label="用户ID"></el-table-column>

        <el-table-column prop="username"
                         label="用户名称"></el-table-column>

        <el-table-column prop="marketid"
                         label="门店ID"></el-table-column>

        <el-table-column prop="marketname"
                         label="门店名称"></el-table-column>

        <el-table-column prop="created_at"
                         label="提交时间">
          <template slot-scope="scope">
            <span>{{(!scope.row.created_at || scope.row.created_at === '0000-00-00 00:00:00') ? '-' : scope.row.created_at}}</span>
          </template>
        </el-table-column>

        <el-table-column prop="score"
                         label="评分">
          <template slot-scope="scope">
            <span>{{scope.row.score || 0}}星</span>
          </template>
        </el-table-column>

        <el-table-column prop="comment"
                         label="评价"></el-table-column>
      </el-table>

      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>


<script>
import table from '@core/mixins/table'



export default {
  mixins: [table],



  data () {
    return {
      search: {
        market: '',
        user: '',
        score: [],
        start_time: '',
        end_time: '',
      },
      searchRules: {
        user: [
          {validator: this.positiveIntegerValidator, trigger: 'blur'},
        ],
        end_time: [
          {validator: this.endTimeValidator, trigger: 'blur'},
        ],
      },
      options: {
        score: ['1', '2', '3', '4', '5'],
      },
      exportHeader: [
        {
          key: 'userid',
          text: '用户ID',
        },
        {
          key: 'username',
          text: '用户名称',
        },
        {
          key: 'marketid',
          text: '门店ID',
        },
        {
          key: 'marketname',
          text: '门店名称',
        },
        {
          key: 'created_at',
          text: '提交时间',
        },
        {
          key: 'score',
          text: '评分',
        },
        {
          key: 'comment',
          text: '评价',
        },
      ],
    }
  },



  methods: {
    getTableData (params) {
      return request.page('getMapCommentFeedbackTable', params)
    },


    positiveIntegerValidator (rule, value, callback) {
      if (value && (!Number.isInteger(Number(value)) || Number(value) <= 0)) {
        callback(new Error('请输入正整数'))
      } else {
        callback()
      }
    },


    endTimeValidator (rule, value, callback) {
      if (Date.parse(this.search.end_time) <= Date.parse(this.search.start_time)) {
        callback(new Error('反馈结束时间必须晚于反馈开始时间'))
      } else {
        callback()
      }
    },


    onExportSearch () {
      this.$export(this.$route.meta.title, {
        request: (params) => request('getMapCommentFeedbackTable', {...this.search, ...params}),
        total: this.pagination.total,
        fileHeader: this.exportHeader,
      })
    },
  },
}
</script>


<style lang="scss"
       scoped
       src="../../platform-user/style/PlatformUser.scss"></style>



// WEBPACK FOOTER //
// src/views/map-comment-feedback/pages/MapCommentFeedbackTable.vue